import { find, findIndex } from "lodash";
import {
  allPeople,
  issues,
  IssueStatus,
  User,
  me,
  IssueActivityType,
} from "../fixtures";

const wait = async (timeout = 350) => {
  await new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
};

export const assignIssuesToUser = async (
  issueIds: string[],
  userId: string | null | undefined,
) => {
  await wait();

  let user: User | undefined;

  if (userId) {
    user = find(allPeople, (person) => person.id === userId);
    if (!user) {
      throw new Error(`Could not find user ${userId}.`);
    }
  } else {
    user = undefined;
  }

  for (const id of issueIds) {
    const issueIdx = findIndex(issues, (issue) => issue.id === id);
    if (issueIdx < 0) {
      continue;
    }

    const issue = issues[issueIdx];

    let nextStatus = issue.status;
    if (issue.status === IssueStatus.Assigned && !user) {
      nextStatus = IssueStatus.Open;
    } else if (issue.status === IssueStatus.Open && user) {
      nextStatus = IssueStatus.Assigned;
    }

    issues[issueIdx] = {
      ...issue,
      assignee: user,
      status: nextStatus,
      activity: [
        {
          id: `issue.activity.${new Date().getMilliseconds()}`,
          type: IssueActivityType.Assigned,
          assigningUserId: me.id,
          assignedUserId: userId,
          date: new Date().toISOString(),
        },
        ...issue.activity,
      ],
    };
  }
};
